import React, { useState } from "react";
import {
  Button,
  Container,
  TextField,
  Typography,
} from "@material-ui/core";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

interface ContactProps {
  cartCount?: number;
  onCartClick?: () => void;
}

const Contact: React.FC<ContactProps> = ({
  cartCount = 0,
  onCartClick = () => {},
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [review, setReview] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    console.log({
      name,
      email,
      review,
    });
  };

  return (
    <div className="contact-page">

      {/* =====================================
          HEADER
      ===================================== */}
      <Header
        cartCount={cartCount}
        onCartClick={onCartClick}
      />

      {/* =====================================
          GOOGLE MAP
      ===================================== */}
      <section className="contact-map-section">
        <iframe
          title="New York Location"
          className="contact-map"
          src="https://www.google.com/maps?q=New%20York&output=embed"
          loading="lazy"
          allowFullScreen
        />
      </section>

      {/* =====================================
          CONTACT CONTENT
      ===================================== */}
      <section className="contact-content-section">
        <Container maxWidth="lg">

          <div className="contact-content-wrapper">

            {/* =================================
                LEFT SIDE - FORM
            ================================= */}
            <div className="contact-form-column">

              <Typography className="contact-eyebrow">
                Please Get in Touch
              </Typography>

              <Typography className="contact-title">
                Contact Us
              </Typography>

              <form
                className="contact-form"
                onSubmit={handleSubmit}
              >

                {/* Name + Email */}
                <div className="contact-input-row">

                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter your name*"
                    value={name}
                    onChange={(event) =>
                      setName(event.target.value)
                    }
                    className="contact-input"
                    // InputProps={{
                    //   disableUnderline: true,
                    // }}
                  />

                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Please Insert Your Email"
                    value={email}
                    onChange={(event) =>
                      setEmail(event.target.value)
                    }
                    className="contact-input"
                    // InputProps={{
                    //   disableUnderline: true,
                    // }}
                  />

                </div>

                {/* Review */}
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  placeholder="Your review *"
                  value={review}
                  onChange={(event) =>
                    setReview(event.target.value)
                  }
                  className="contact-review-input"
                //   InputProps={{
                //     disableUnderline: true,
                //   }}
                />

                {/* Submit */}
                <div className="contact-submit-wrapper">
                  <Button
                    type="submit"
                    variant="contained"
                    className="contact-submit-button"
                  >
                    SUBMIT
                  </Button>
                </div>

              </form>
            </div>

            {/* =================================
                RIGHT SIDE - CONTACT CARD
            ================================= */}
            <div className="contact-info-column">

              <div className="contact-info-card">

                <Typography className="contact-city">
                  New York
                </Typography>

                <div className="contact-card-divider" />

                <Typography className="contact-address">
                  94 Academy Street
                </Typography>

                <Typography className="contact-address">
                  Barrington, London
                </Typography>

                <Typography className="contact-phone">
                  Tel: +44 (0)20 7405 7686
                </Typography>

              </div>

            </div>

          </div>

        </Container>
      </section>

      <Footer />

    </div>
  );
};

export default Contact;